import React from 'react';
import { Link } from 'gatsby';
import Heading from '@codedrop/typography/esm/heading';
import Tag from '@codedrop/tag/esm/tag';

const Card = ({
  cardClass,
  cardHeading,
  cardLinkUrl,
  cardLinkText,
  children,
  cardTagClass,
  cardTagText
}) => /*#__PURE__*/React.createElement("div", {
  className: "card ".concat(cardClass)
}, cardTagText ? /*#__PURE__*/React.createElement("div", {
  className: "card__tags"
}, /*#__PURE__*/React.createElement(Tag, {
  tagClass: cardTagClass,
  tagText: cardTagText
})) : '', cardHeading ? /*#__PURE__*/React.createElement(Heading, {
  tag: "h3",
  headingClass: "card__heading heading--m"
}, cardHeading) : '', /*#__PURE__*/React.createElement("div", {
  className: "card__content"
}, children), cardLinkUrl ? /*#__PURE__*/React.createElement("div", {
  className: "card__footer"
}, /*#__PURE__*/React.createElement(Link, {
  to: cardLinkUrl,
  className: "card__link"
}, cardLinkText)) : '');

Card.displayName = 'Card';
Card.defaultProps = {
  cardClass: '',
  cardHeading: 'Card Heading',
  cardLinkUrl: '',
  cardLinkText: '',
  cardTagClass: '',
  cardTagText: ''
};
export default Card;